<div class="flex h-full w-full flex-col gap-1 py-5">
  @if (!!member().fullName) {
    <div class="flex gap-2">
      <span class="text-gray-2">ПІБ</span>
      <span class="flex-1 text-end">{{ member().fullName }}</span>
    </div>
  }
  @if (!!member().phoneNumber) {
    <div class="flex gap-2">
      <span class="text-gray-2">Телефон</span>
      <span class="flex-1 text-end">{{ member().phoneNumber }}</span>
    </div>
  }
  @if (!!member().email) {
    <div class="flex gap-2">
      <span class="text-gray-2">Пошта</span>
      <span class="flex-1 text-end">{{ member().email }}</span>
    </div>
  }
  @if (!!member().birthDate) {
    <div class="flex gap-2">
      <span class="text-gray-2">Дата народження</span>
      <span class="flex-1 text-end">{{ formatDate(member().birthDate) }}</span>
    </div>
  }
  @if (!!member().doctorName) {
    <div class="flex gap-2">
      <span class="text-gray-2">Лікар</span>
      <span class="flex-1 text-end">{{ member().doctorName }}</span>
    </div>
  }

  @if (!!memberContracts().length) {
    <shared-contract-item
      [type]="'list-items'"
      [contracts]="memberContracts()"
    ></shared-contract-item>
  }

  <div class="p-3">
    <mat-divider></mat-divider>
  </div>

  <div class="flex flex-col gap-4">
    <h4>Коментарі</h4>
    <div class="flex max-h-[36vh] flex-col gap-3 overflow-y-auto overflow-x-hidden">
      @for (comment of memberProfileComments(); track $index) {
        <div class="flex justify-between rounded-lg bg-blue-light p-1 px-2 shadow-md">
          <span class="flex flex-col gap-2">
            <span class="text-xs underline">{{ comment.creatorName }}</span>
            <span class="text-md">{{ comment.content }}</span>
          </span>

          <div class="flex flex-col items-end text-xs">
            <span>{{ formatDate(comment.createdAt, true) }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
